<template>
  <div>
    <div class="banner">
      <div class="banner-search">
        <div>
          <div class="search-item">
            <p>咨询服务</p>
            <div></div>
          </div>
        </div>
      </div>
      <el-carousel
        class="banner-imgs"
        :interval="8000"
        indicator-position="none"
      >
        <el-carousel-item v-for="(bannerImg, index) in bannerList" :key="index">
          <a :href="bannerImg.urlAddr">
            <img
              :src="
                bannerImg.url
                  ? bannerImg.url
                  : require('@/assets/imgs/banner_zc.png')
              "
              style="width: 100%; height: 100%"
            />
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="w">
      <div class="locate">
        <p>当前位置 > {{title}}</p>
      </div>

      <div id="division"></div>

      <!-- <div id="nav1">
            <div @click="ask">咨询服务</div>
            <div @click="consult">投诉服务</div>
        </div> -->

      <consult :buttonName="buttonName" :type="type"></consult>
    </div>
  </div>
</template>

<script>
import consult from "./Consult.vue";
export default {
  name: "CompanyIntroduction",
  components: {
    consult,
  },
  data() {
    return {
      title: "咨询服务",
      buttonName: "我要咨询",
      type: "0",
      bannerList: [
        {
          url: require("@/assets/imgs/banner_zc.png"),
          urlAddr: "#",
        },
      ],
    };
  },
  methods: {
    ask() {
      this.title = "咨询服务";
      this.buttonName = "我要咨询";
      this.type = "0";
    },
    consult() {
      this.title = "投诉服务";
      this.buttonName = "我要投诉";
      this.type = "1";
    },
  },
};
</script>

<style lang="scss" scoped>
.w {
  width: 1176px;
  height: auto;
  margin: 41px auto;
  display: block;
}

.locate {
  width: 270px;
  height: 15px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  text-align: left;
}

#division {
  border-top: 1px solid #dedede;
  margin: 24px 0;
  height: 1px;
  width: 100%;
}

#nav1 {
  display: flex;
  font-size: 20px;
}
#nav1 div {
  flex: 1;
  cursor: pointer;
}
#nav1 div:nth-child(1) {
  border-right: 1px solid #ccc;
}

/* 导航图片 */
.banner {
  width: 100%;
  position: relative;
  height: 290px;
  margin: 146px auto 0;
}

.banner-search {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100px;
  z-index: 99;
  height: 85px;
}

.banner-imgs {
  height: 100%;
  width: 100%;
}

.banner-img .el-carousel__indicators {
  z-index: 10000;
}

.banner .banner-title {
  height: 130px;
  margin-bottom: 50px;
}
.search-item {
  width: 791px;
  min-width: 750px;
  max-width: 1000px;
  text-align: center;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0);
  border-radius: 10px;
  padding: 19px 25px 18px 23px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 22px;
  align-items: center;
}

.search-item div {
  width: 29px;
  height: 4px;
  background: #ffffff;
  margin: 11px auto;
}
</style>